import { HttpService } from '@skylab-shared/core';
import { EventNotification, EventNotificationsServiceBase, EventNotificationType } from '../../event-notifications.service-base';
import { NotificatorBase } from '../notificator-base';

export class PreparingDataNotificatorBase extends NotificatorBase<void, void> {
    protected readonly eventType: EventNotificationType = 'PreparingData';

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }

    protected prepareDataAsync(_: EventNotification<unknown>[] | null = null): Promise<void> {
        return Promise.resolve(void 0);
    }
}
